import Login from "../components/admin/Login";
import './AdminPage.css';


const AdminPage = () => {
    return (
        <div>
            <Login/>
        </div>
    )
}

export default AdminPage;